/* Dansk katalog for locale-bank-misc-no.js (del 1 av 3).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'bank.analysis.running': 'Analyserer …',
  'bank.analysis.completed': 'Analyseret af SuperPlumma',
  'bank.analysis.start': 'Start analyse',
  'bank.analysis.retry': 'Prøv analysen igen',
  'bank.periodImport.dropFile': 'Slip bankfilen her',
  'bank.periodImport.missingMonth': 'Mangler kontoudtog for {{period}}',
  'bank.periodImport.monthUploadHelp': 'Upload CSV, PDF eller XLSX for {{account}}. Filen kan dække én eller flere måneder, uanset hvilken måned du står i. Banklinjerne fordeles automatisk på den rigtige måned efter dato. Du kan også supplere en tidligere import med et nyt kontoudtog.',
  'bank.periodImport.title': 'Upload bankfil',
  'bank.periodImport.help': 'Upload transaktioner eller kontoudtog for én eller flere måneder. Uploaden er uafhængig af den måned, du har valgt.',
  'bank.periodImport.chooseAccount': 'Vælg bankkonto',
  'bank.periodImport.coverageHelp': 'Kontroller eksportens periode. Første og sidste transaktionsdato er kun et forslag; dage uden transaktioner kan også være med.',
  'bank.periodImport.from': 'Eksport fra og med',
  'bank.periodImport.to': 'Eksport til og med',
  'bank.periodImport.confirmCoverage': 'Filen indeholder alle bankbevægelser i denne periode, uden søge- eller beløbsfilter.',
  'bank.periodImport.closing': 'Ultimo banksaldo (UB)',
  'bank.periodImport.balanceHelp': 'Saldiene er valgfrie ved import. Brug bankens bogførte saldo lige før startdatoen og ved udgangen af slutdatoen. Lad feltet stå tomt, hvis saldoen er ukendt. Et senere kontoudtog kan supplere med primo/ultimo (IB/UB).',
  'bank.periodImport.preview': 'Kontroller import',
  'bank.periodImport.save': 'Importer bankfil',
  'bank.periodImport.continue': 'Fortsæt, hvor jeg slap',
  'bank.periodImport.process': 'Behandl hele perioden',
  'bank.periodImport.result': '{{added}} nye transaktioner · {{matched}} genkendt',
  'bank.periodImport.preserved': 'Tidligere behandling, posteringer og bilagskoblinger er bevaret.',
  'bank.periodImport.fileMissing': 'Transaktionerne er gemt, men den originale fil kunne ikke gemmes. Upload filen igen for at bevare dokumentationen.',
  'bank.periodImport.monthLines': '{{count}} linjer',
  'bank.periodImport.balanceFound': 'UB registreret',
  'bank.periodImport.balanceMissing': 'Banksaldo mangler',
  'bank.periodImport.chooseMatch': 'Vælg eksisterende transaktion med anden tekst',
  'bank.periodImport.newTransaction': 'Dette er en selvstændig, ny transaktion',
  'bank.periodImport.worklist': 'Bank · samlet arbejdsliste',
  'bank.periodImport.worklistHelp': 'Behandl linjerne løbende på tværs af månederne. Hver måned har stadig sin egen saldokontrol og afstemning.',
  'bank.periodImport.needBalances': 'Banksaldo mangler. Du kan behandle linjerne nu og supplere med kontoudtog eller dokumenteret IB/UB før afstemning.',
  'bank.periodImport.partial': 'Dette er en delvis måned. Behandl linjerne nu, og supplér resten af måneden, før den færdiggøres.',
  'bank.periodImport.files': 'Importerede originalfiler',
  'bank.periodImport.openPeriods': 'Åbn importerede perioder',
  'bank.control.ledgerDifference': '{{month}}: Bogført UB {{booked}}, bankens UB {{bank}}. Afvigelse {{difference}}. Måneden skal kontrolleres igen.',
  'bank.control.openingLedgerDifference': '{{month}}: Bankens IB {{bank}}, IB i hovedbogen {{booked}}. Afvigelse {{difference}}. Registrer en afstemt åbningsbalance under Regnskab, før afstemningen færdiggøres.',
  'bank.control.ledgerMismatchTitle': 'Afvigelse mod hovedbogen',
  'bank.archiveLedgerMismatch': 'Kan ikke arkivere: bogført saldo pr. {{date}} er {{booked}} kr, mens bankens saldo er {{bank}} kr. Afvigelse {{difference}} kr.',
  'bank.statementDiscrepancy': 'Afvigelse i kontoudtog',
  'bank.balanceDiscrepancy': 'Saldoafvigelse',
  'bank.balanceDiscrepancyHelp': 'Forskellen mellem bogført saldo og bankens ultimosaldo.',
  'bank.removedLineCannotBook': 'En fejllæst banklinje, der er fjernet fra afstemningen, kan ikke bogføres.',
  'bank.control.missingBalance': '{{month}}: Kontoudtoget mangler UB. Bogført UB er {{booked}}. Saldiene er ikke kontrolleret mod hinanden.',
  'bank.control.ready': 'Kontoudtogene dækker perioden og er afstemt.',
  'bank.control.openingSetupMissing': '{{account}} mangler startdato eller startsaldo. Udfyld begge i bankindstillingerne; skriv 0, hvis saldoen var nul.',
  'bank.control.needsReview': 'Bankkontrollen har ufuldstændigt startgrundlag, manglende kontoudtog, uafstemte perioder, saldoafvigelser eller posteringer før startsaldoen.',
  'bank.control.missing': 'Mangler kontoudtog for {{year}}: {{months}}.',
  'bank.control.unsettled': 'Kontoudtog er uploadet, men ikke færdigafstemt for {{year}}: {{months}}.',
  'bank.control.existingBeforeStart': '{{count}} postering(er) er dateret før startsaldoen {{date}}. Kontroller posteringerne og startsaldoen i bankindstillingerne. Startsaldoen ændres ikke automatisk af tidligere posteringer.',
  'bank.control.postingBeforeStart': 'Posteringen er dateret før startsaldoen for bankkonto {{account}} ({{date}}). Kontroller dato og startsaldo i bankindstillingerne, før du bogfører.',
  'bank.patternBased': 'Baseret på tidligere mønster',
  'bank.patternTitle': 'Tidligere mønster',
  'bank.patternExplanation': 'Plumme foreslår denne behandling, fordi lignende banklinjer tidligere er bogført på samme måde. Forslaget skal stadig godkendes. Du kan stoppe mønsteret uden at ændre tidligere posteringer.',
  'bank.patternVariableAmounts': 'Plumme husker type og konto, men genbruger ikke tidligere afdrag, renter eller gebyrer. Beløbene skal kontrolleres mod dokumentationen hver gang.',
  'bank.patternStop': 'Brug ikke mønsteret',
  'bank.patternStopped': 'Mønsteret er stoppet',
  'bank.patternStopFailed': 'Kunne ikke stoppe mønsteret.',
  'bank.backToYearClosing': 'Tilbage til årsafslutning',
  'bank.editEntry': 'Rediger postering',
  'bank.bankLine': 'Banklinje',
  'bank.saveAndPost': 'Gem og bogfør',
  'bank.readFrom': 'Oplysningerne er aflæst fra',
  'bank.voucherType': 'Bilagstype',
  'bank.purchaseVoucher': 'Købsbilag',
  'bank.salesVoucher': 'Salgsbilag',
  'bank.counterparty': 'Modpart',
  'bank.supplierOrParty': 'Leverandør / modpart',
  'bank.businessAccount': 'Virksomhedskonto',
  'bank.paidPrivately': 'Betalt privat',
  'bank.uploadOrForward': 'Upload eller videresend bilag pr. e-mail — vi aflæser det, vi kan.',
  'bank.uploadedReceived': 'Uploadet/modtaget',
  'bank.searchVouchers': 'Søg i bilag — filnavn, PDF, billede…',
  'bank.noInboxVouchers': 'Ingen bilag i indbakken endnu',
  'bank.noInboxVouchersHelp': 'Upload et bilag, eller videresend leverandørfakturaer til bilagsadressen.',
  'bank.allMonths': 'Alle måneder',
  'bank.uploading': 'Uploader …',
  'bank.uploadingCount': 'Uploader {{done}}/{{total}} …',
  'bank.analyzingCount': 'Analyserer {{done}}/{{total}} …',
  'bank.dragToReorder': 'Træk for at ændre rækkefølge',
  'bank.editTheEntry': 'Rediger posteringen',
  'bank.moveToTrash': 'Flyt til papirkurven',
  'bank.dropFilesHere': 'Slip filerne her',
  'bank.weReadWhatWeCan': 'Vi aflæser det, vi kan',
  'bank.deleteForeverTitle': 'Slet for altid?',
  'bank.deleteForever': 'Ja, slet permanent',
  'km.time': 'Tid',
  'km.avgSpeed': 'Gennemsnitsfart',
  'km.useDistance': 'Brug distance',
  'km.searching': 'Søger...',
  'km.from': 'Fra',
  'km.to': 'Til',
  'km.resolvingAddress': 'Finder adresse...',
  'km.gpsGapTitle': 'Hul i GPS-sporet',
  'km.gpsGap': 'Sporingen mistede positionen undervejs, og {km} km er ikke medregnet. Kontroller kilometertallet, før du gemmer turen.',
  'km.sub': 'Registrér køreture, og hold styr på kørselsgodtgørelsen.',
  'km.newTripOrLog': 'Ny tur / Kørebog',
  'km.newTripOrLogHelp': '»Ny tur« registrerer en ny køretur. »Kørebog« viser oversigten over alle de ture, du har ført, med samlet distance og fradrag.',
  'km.tripDetails': 'Detaljer for turen',
  'km.tripDetailsHelp': 'Udfyld de oplysninger, der dokumenterer køreturen: dato, formål (hvorfor du kørte), fra- og til-sted samt antal kilometer. Formålet er vigtigt — turen skal være erhvervsmæssig for at give fradrag.',
  'km.purposePh': 'F.eks. kundemøde hos Lunde & Vik',
  'km.purposeQuickPicks': 'Hurtigvalg',
  'km.returnTrip': 'Tur/retur',
  'km.returnTripHelp': 'Sæt kryds, når du kørte samme vej tilbage. Kilometerne og fradraget fordobles, og turen dokumenteres som tur/retur i kørebogen.',
  'km.returnTripRow': 'Tur/retur',
  'km.perLeg': 'Én vej',
  'km.removeStop': 'Fjern stop',
  'km.addStop': 'Tilføj stop',
  'km.addStopHelp': 'Tilføj et stop mellem start og destination — nyttigt, når turen går forbi flere steder. Hvert stop bliver en del af ruten, der dokumenteres.',
  'km.calcAuto': 'Beregn km automatisk',
  'km.calcAutoHelp': 'Beregner automatisk antal kilometer mellem fra-, stop- og til-sted ved hjælp af kort, så du ikke selv skal slå afstanden op.',
  'km.ratePerKm': 'Sats pr. km',
  'km.ratePerKmHelp': 'Statens sats for kørselsgodtgørelse pr. kilometer. Plumme bruger automatisk den gældende sats til at beregne fradraget.',
  'km.registeredDistance': 'Registreret distance',
  'km.registeredDistanceHelp': 'Antal kilometer, du har indtastet for denne tur.',
  'km.deductionAmount': 'Fradragsbeløb',
  'km.deductionAmountHelp': 'Kilometer gange satsen — det skattefri beløb, du kan få i kørselsgodtgørelse for turen.',
  'km.saveHelp': 'Gemmer køreturen i kørebogen. Den tæller med i årets samlede distance og fradrag og kan dokumenteres ved en eventuel kontrol.',
  'km.drivenThisYear': 'Kørt i år',
  'km.drivenThisYearHelp': 'Samlet antal kilometer erhvervskørsel, du har registreret indtil nu i år.',
  'km.deductionThisYear': 'Fradrag i år',
  'km.deductionThisYearHelp': 'Samlet kørselsgodtgørelse (fradrag) for årets registrerede ture.',
  'km.searchPh': 'Søg på rute, formål eller dato',
  'km.deleteTripTitle': 'Slet køretur?',
  'km.deleteTripConfirm': 'Ja, slet',
  'bank.alreadyPostedToOperating': 'Allerede bogført mod driftskonto',
  'bank.openInJournal': 'Åbn i bilagsjournal',
  'bank.noEntriesInView': 'Ingen poster i denne visning.',
  'bank.fixUp': 'Korrigér',
  'bank.pickLine': 'Vælg linje',
  'bank.noFreeLines': 'Ingen ledige banklinjer i dette kontoudtog.',
  'bank.link': 'Tilknyt',
  'bank.statement': 'Kontoudtog',
  'bank.openOriginal': 'Åbn original',
  'bank.downloadCsv': 'Download CSV',
  'bank.openingBalance': 'Indgående saldo',
  'bank.originalNotDownloadable': 'Originalfilen kan ikke downloades.',
  'bank.viewUsesImported': 'Visningen nedenfor bruger de banklinjer, der allerede er importeret.',
  'bank.balance': 'Saldo',
  'bank.noImportedLines': 'Ingen importerede banklinjer i dette kontoudtog.',
  'bank.importNoTransactions': 'Fandt ingen transaktioner i »{{fileName}}«, men saldiene viser en bevægelse på {{difference}}. Kontrollér linjerne mod originalen, før du afstemmer. Kontoudtoget blev ikke gemt.',
  'bank.importBalanceMismatch': 'Aflæsningen stemmer ikke med saldiene i kontoudtoget: {{difference}} i difference. Kontrollér linjerne mod originalen, før du afstemmer. Kontoudtoget blev ikke gemt.',
  'bank.importUnreadablePeriod': 'Kunne ikke læse perioden i kontoudtoget. Kontoudtoget blev ikke gemt.',
  'bank.imageAnalysisUnavailable': 'Billedanalyse af kontoudtog er ikke tilgængelig endnu.',
  'bank.importFailed': 'Kunne ikke læse kontoudtoget.',
  'bank.readingStatement': 'Læser kontoudtoget…',
  'bank.openStatementPreview': 'Åbn forhåndsvisning af kontoudtoget',
  'bank.seeOriginal': 'Se kontoudtog',
  'bank.almostDone': 'Næsten i mål',
  'bank.linesRemaining': 'linjer mangler at blive behandlet',
  'bank.discrepancy': 'Afvigelse',
  'bank.discrepancyHelp': 'Beregnet afvigelse mellem saldo og banklinjer',
  'bank.openingBalanceHelp': 'Saldoen på bankkontoen ved periodens start — hentet fra den forrige afstemning.',
  'bank.closingBalanceHelp': 'Saldoen på bankkontoen ved periodens slutning ifølge kontoudtoget. Den skal stemme med den bogførte saldo, når alle linjer er behandlet.',
  'bank.useSuperPlumma': 'Brug SuperPlumma',
  'bank.useSuperPlummaHelp': 'Lader SuperPlumma finde forslag til kontrol. Du godkender resultatet før bogføring.',
  'bank.reconcileAndPost': 'Afstem og bogfør',
  'bank.chronologicalTitle': 'En tidligere periode er ikke afstemt',
  'bank.chronologicalBody': 'Afstem {{period}} først. Indgående saldo hentes fra det forrige kontoudtog, så en afvigelse der ville blive usynlig her.',
  'bank.reconcileAndPostHelp': 'Bogfører banklinjerne, låser perioden, når alle linjer er behandlet, og flytter kontoudtoget til arkivet.',
  'bank.reconcileAndArchive': 'Afstem og arkivér',
  'bank.reconcileAndArchiveHelp': 'Bogfører banklinjerne, låser perioden, når alle linjer er behandlet, og flytter kontoudtoget til arkivet.',
  'bank.existingEntryMatch.action': 'Match bogført post',
  'bank.existingEntryMatch.title': 'Match bogført post',
  'bank.existingEntryMatch.help': 'Vælg den post, der allerede fører det samme bankbeløb. Der oprettes ingen ny bogføring.',
  'bank.existingEntryMatch.dateMismatch': 'Datoen afviger med {days} dage. Kontrollér posten, før du tilknytter.',
  'bank.existingEntryMatch.none': 'Der blev ikke fundet bogførte poster med samme beløb og nærliggende dato.',
  'bank.existingEntryMatch.success': 'Banklinjen er tilknyttet den bogførte post.',
  'bank.existingEntryMatch.error': 'Kunne ikke tilknytte banklinjen.',
  'bank.reopenAndReverse': 'Genåbn og tilbagefør',
  'bank.reopenAndReverseHelp': 'Genåbner det afstemte kontoudtog, så bogføringen kan rettes. Perioden låses op.',
  'bank.settledTitle': 'Afstemt og bogført',
  'bank.settledOn': 'Arkiveret {{date}}',
  'bank.settledHelp': 'Kontoudtoget ligger i arkivet.',
  'bank.settledBadge': 'Afstemt',
  'bank.alreadySettled': 'Kontoudtoget er allerede afstemt og arkiveret. Genåbn det, hvis noget skal rettes.',
  'bank.postedToOperating': 'Bogført mod driftskonto',
  'bank.postedToOperatingHelp': 'Disse posteringer er bogført på driftskontoen for denne bankperiode.',
  'bank.linkVoucher': 'Tilknyt',
  'bank.openLinkedVoucher': 'Åbn {{name}}',
  'bank.openingBalanceImported': 'Aflæst fra kontoudtoget: {{amount}}',
  'bank.useExpectedOpening': 'Sæt indgående saldo til {{amount}}',
  'bank.receiptLinked': 'Tilknyttet banklinje',
  'bank.duplicateUpload': 'Mulig dobbelt upload',
  'bank.ambiguousMatch': 'Flere ens bilag — vælg selv, hvilket der hører til',
  'bank.linkSuggestedVouchers': 'Tilknyt {{count}} foreslåede bilag',
  'bank.searchLines': 'Søg i banklinjer…',
  'bank.addLine': 'Tilføj banklinje',
  'bank.noLinesInView': 'Ingen banklinjer i denne visning.',
  'bank.missingVoucher': 'Mangler bilag',
  'bank.missingVoucherAction': 'Mangler bilag · klik eller træk hertil',
  'bank.missingVoucherHelp': 'Træk et bilag fra indbakken hertil for at tilknytte det. Hvis bilaget er bortkommet eller ikke kan fremskaffes, kan du klikke og registrere det som bortkommet.',
  'bank.markVoucherLostTitle': 'Markér bilag som bortkommet',
  'bank.markVoucherLostHelp': 'Bogføringen bevares, men dette erstatter ikke dokumentation. Opfølgningen lukkes, og valget gemmes på banklinjen med begrundelse, tidspunkt og bruger.',
  'bank.markVoucherLostConfirm': 'Registrér',
  'bank.markVoucherLostSaving': 'Registrerer …',
  'bank.voucherLostReason': 'Forklaring',
  'bank.voucherLostReasonHint': 'Påkrævet. Forklar, hvorfor bilaget ikke kan skaffes.',
  'bank.voucherLostReasonPlaceholder': 'F.eks. kvitteringen er bortkommet, og leverandøren kan ikke sende en kopi.',
  'bank.voucherLostReasonRequired': 'Skriv kort, hvorfor bilaget ikke kan skaffes.',
  'bank.voucherLostError': 'Kunne ikke markere bilaget som bortkommet.',
  'bank.voucherLostUnavailable': 'Markering af bortkomne bilag er ikke koblet til backend.',
  'bank.docReason.lostText': 'Bilaget er bortkommet og kan ikke fremskaffes.',
  'bank.docReason.never': 'Aldrig modtaget',
  'bank.docReason.neverText': 'Leverandøren har ikke sendt kvittering eller faktura.',
  'bank.docReason.statementOnly': 'Kun i kontoudtoget',
  'bank.docReason.statementOnlyText': 'Transaktionen står kun i kontoudtoget, og der findes ikke et selvstændigt bilag.',
  'bank.docReason.notApplicable': 'Ikke relevant',
  'bank.docReason.notApplicableText': 'Et selvstændigt bilag er ikke relevant for denne postering.',
  'bank.voucherMarkedLost': 'Bilag bortkommet',
  'bank.voucherMarkedLostToast': 'Bilaget er markeret som bortkommet',
  'bank.sendVoucherBack': 'Send bilaget tilbage til indbakken',
  'bank.approveSuggestion': 'Godkend forslag',
  'bank.approveSuggestionHelp': 'Accepterer SuperPlummas konteringsforslag for linjen og bogfører den sådan.',
  'bank.review': 'Kontrollér',
  'bank.markPrivate': 'Markér som privat',
  'bank.post': 'Bogfør',
  'bank.reviewEntries': 'Kontrollér poster',
  'bank.previewUnavailable': 'Forhåndsvisning er ikke tilgængelig',
  'bank.previewUnavailableHelp': 'Bilaget mangler en tilgængelig filadresse.',
  'bank.noVatCalculated': 'Der beregnes ingen moms. Hele bankbeløbet på',
  'bank.amountExVatBecomes': 'Beløbet ekskl. moms bliver',
  'bank.actualAmountIncVat': 'Faktisk bankbeløb inkl. moms bliver',
  'bank.saveAndClose': 'Gem og luk',
  'bank.manualLine': 'Manuel banklinje',
  'bank.amountExInc': 'Bankbeløb ekskl./inkl. moms',
  'bank.amountExIncHelp': 'Tryk for at skifte mellem at vise beløbet med eller uden moms. Plumme omregner automatisk, mens det faktiske beløb fra banktransaktionen stadig gemmes inkl. moms.',
  'bank.costAccount': 'Omkostningskonto',
  'bank.accountCategory': 'Konto/kategori',
  'bank.salesAccount': 'Salgskonto',
  'bank.pickOpenInvoice': 'Vælg åben faktura',
  'bank.noMatchingInvoices': 'Ingen åbne fakturaer matcher dette beløb.',
  'bank.matchesVatPeriod': 'Matcher den valgte momstermin. Bogføring og markering som betalt sker, når terminen kobles.',
  'bank.mixedUseManual': 'Hvis linjen blander moms, skat, korrektioner eller andre justeringer, så brug fri postering.',
  'bank.matchesPayrollPeriod': 'Matcher den valgte termin for skattetræk/AGA. Vælg, hvilken del banklinjen faktisk betaler.',
  'bank.payrollPeriod': 'Termin for skattetræk / AGA',
  'bank.whatIsPaymentFor': 'Hvad vedrører betalingen?',
  'bank.payrollAccountsHelp': 'Skattetræk er 2600, arbejdsgiverafgift er 2770.',
  'bank.feeHelp': 'Brug denne til bank- og kortgebyrer. Beløbet bogføres uden moms mod',
  'bank.noFeeAccount': 'Der findes ingen egnet gebyrkonto i kontoplanen.',
  'bank.roundingHelp': 'Brug kun dette til en reel lille afrundingsdifference. Beløbet bogføres uden moms mod',
  'bank.swapFromTo': 'Byt fra og til',
  'bank.pickTwoAccounts': 'Vælg to forskellige konti, før du gemmer den frie postering.',
  'bank.manualPostingBankMismatch': 'Summen på bankkontoen i posteringen skal svare til banklinjen.',
  'bank.supplierVatHelp': 'Momssatsen på leverandørfakturaen. Indgående moms beregnes ud fra beløbet.',
  'bank.supplierDueDateHelp': 'Forfaldsdatoen på leverandørens faktura. Dækker banklinjen kun en del af beløbet, er resten stadig en åben post — og fristen er den, aldersfordelingen beregnes fra.',
  'bank.supplierInvoiceGross': 'Fakturaens totalbeløb',
  'set.bank.currency': 'Valuta',
  'set.bank.accountNumberHelp': 'Kontonummeret, som banken oplyser det. Punktummer og mellemrum fjernes automatisk — regnskabet, importfilerne og betalingerne sammenligner cifrene, og et nummer med skilletegn matcher ikke sit eget kontoudtog.',
  'set.bank.currencyName.NOK': 'Norske kroner',
  'set.bank.currencyName.SEK': 'Svenske kroner',
  'set.bank.currencyName.DKK': 'Danske kroner',
  'set.bank.currencyName.EUR': 'Euro',
  'set.bank.currencyName.USD': 'Amerikanske dollar',
  'set.bank.currencyName.GBP': 'Britiske pund',
  'set.bank.currencyName.CHF': 'Schweiziske franc',
  'set.bank.currencyName.ISK': 'Islandske kroner',
  'set.bank.currencyName.PLN': 'Polske zloty',
  'set.bank.currencyName.CZK': 'Tjekkiske koruna',
  'set.bank.currencyName.JPY': 'Japanske yen',
  'set.bank.currencyName.CAD': 'Canadiske dollar',
  'set.bank.currencyName.AUD': 'Australske dollar',
  'set.loans.title': 'Låneregister',
  'set.loans.sub': 'Lån og langfristet gæld med afdragsplan',
  'set.loans.help': 'Et lån er ellers bare en hovedbogskonto. Saldoen viser, hvad der står tilbage, men ikke hvor meget der forfalder det næste år — og uden det kan kortfristet og langfristet gæld ikke adskilles. Afdragene bogføres som før, via bank eller bilag.',
  'set.loans.none': 'Ingen lån registreret.',
  'set.loans.add': 'Tilføj lån',
  'set.loans.remove': 'Slet lån',
  'set.loans.lender': 'Långiver',
  'set.loans.ledgerAccount': 'Hovedbogskonto',
  'set.loans.ledgerAccountHelp': 'Kontoen, lånet står på. Uden den kan lånet ikke afstemmes mod regnskabet.',
  'set.loans.missingAccount': 'Mangler konto',
  'set.loans.originalAmount': 'Oprindeligt lånebeløb',
  'set.loans.interestRate': 'Rente (%)',
  'set.loans.startDate': 'Startdato',
  'set.loans.repaymentType': 'Afdragstype',
  'set.loans.termsPerYear': 'Terminer pr. år',
  'set.loans.monthly': 'Månedlig (12)',
  'set.loans.quarterly': 'Kvartalsvis (4)',
  'set.loans.halfYearly': 'Halvårlig (2)',
  'set.loans.yearly': 'Årlig (1)',
  'set.loans.installmentAmount': 'Terminsbeløb',
  'set.loans.installmentHelp': 'Afdraget pr. termin for serielån, hele terminsbeløbet for annuitetslån.',
  'set.loans.remainingTerms': 'Resterende terminer',
  'set.loans.interestOnlyUntil': 'Afdragsfrit til',
  'set.loans.interestOnlyHelp': 'Lad feltet stå tomt, hvis lånet ikke er afdragsfrit.',
  'set.loans.security': 'Pant og sikkerhed',
  'set.loans.planIncomplete': 'Planen er ikke komplet nok til at beregne, hvad der forfalder det næste år. Afstemningen giver besked i stedet for at gætte.',
  'set.loans.planSays': 'Ifølge planen forfalder {amount} i de næste tolv måneder. Klassificeringen kortfristet/langfristet er stadig en faglig vurdering.',
  'set.bank.currencyHelp': 'Kontoens egen valuta. NOK for almindelige norske konti. En konto i en anden valuta afstemmes ved omregning til balancedagens kurs, ikke ved direkte sammenligning.',
  'bank.supplierInvoiceGrossHelp': 'Udfyld kun, hvis banklinjen dækker en del af fakturaen. Så registreres fakturaen med sit fulde beløb, og det, banklinjen betaler, føres som en delbetaling — resten bliver stående som udestående hos leverandøren.',
  'bank.shortDescriptionPh': 'Kort beskrivelse af transaktionen…',
  'bank.previewVoucher': 'Forhåndsvis bilaget',
  'bank.noVoucherUploaded': 'Intet bilag uploadet',
  'bank.fetchFromInbox': 'Hent fra Indbakke',
  'bank.backToBank': 'Tilbage til bank',
  'bank.privateBank': 'Privat bank',
  'bank.privateBankHelp': 'Privatkontoen bruges som et oprydningsværktøj: gå linjerne igennem, markér dem, der i virkeligheden er firmaudgifter, som »Drift« (de bogføres så på driftskontoen), og ignorér de rent private. Sådan får du firmaomkostninger med, som du har lagt ud for privat.',
  'bank.finishReview': 'Afslut gennemgang',
  'bank.finishReviewHelp': 'Bogfører de linjer, du har markeret som drift, på driftskontoen og arkiverer den færdiggennemgåede private kontoudskrift.',
  'bank.dragVoucherFromInbox': 'Træk bilag fra indbakken',
  'bank.toOperations': 'Til driften',
  'bank.toOperationsHelp': 'Åbner bogføringsvalgene for linjen, så konto, moms, bilag og type bliver korrekte, før den flyttes til driften.',
  'bank.ignore': 'Ignorer',
  'bank.ignoreHelp': 'Markér linjen som rent privat, og hold den uden for virksomhedens regnskab. Tryk igen for at fortryde.',
  'bank.voucherReceivedOn': 'Bilag modtaget den',
  'bank.superPlummaFetches': 'SuperPlumma henter og tilknytter',
  'bank.searchInbox': 'Søg i indbakken...',
  'bank.reopen': 'Åbn igen',
  'bank.viewPostings': 'Se posteringer',
  'bank.waitingPrevious': 'Venter på forrige',
  'bank.waitingPreviousHelp': 'Du kan åbne og kontrollere kontoudskriften nu, men den kan ikke bogføres eller afstemmes, før den forrige kontoudskrift er færdig.',
  'bank.previousMustReconcile': 'Den forrige kontoudskrift skal afstemmes først. Du kan kontrollere denne kontoudskrift, men ikke bogføre eller afstemme den endnu.',
  'bank.openStatement': 'Åbn kontoudskrift',
  'bank.deleteStatement': 'Slet kontoudskrift',
  'bank.deleteStatementTitle': 'Slet kontoudskrift?',
  'bank.deleteStatementConfirm': '{{fileName}} fjernes permanent. Bogførte posteringer og bilag slettes ikke, men mister tilknytningen til kontoudskriften. De står uden bankafstemning, indtil du uploader en kontoudskrift for perioden — så matches de automatisk eller vises som afvigelser. Dette kan ikke fortrydes.',
  'bank.statementFallback': 'Kontoudskriften',
  'bank.deleteUnavailable': 'Sletning af kontoudskrifter er ikke tilgængelig endnu.',
  'bank.deleteSuccess': 'Kontoudskriften er slettet',
  'bank.deleteReopenFirst': 'Åbn kontoudskriften igen, før den slettes.',
  'bank.deleteNewerFirst': 'Nyere kontoudskrifter skal slettes først. Behandlede kontoudskrifter slettes fra nyeste til ældste.',
  'bank.deleteError': 'Kunne ikke slette kontoudskriften.',
  'bank.deleteSettledBlocked': 'Afstemte eller bogførte kontoudskrifter kan ikke slettes.',
  'bank.deleteReverseFirst': 'Bogføringen skal tilbageføres, før kontoudskriften kan slettes.',
  'bank.deleteMatchGroupBlocked': 'Kontoudskriften indgår i en bogført matchgruppe. Tilbagefør gruppen, før kontoudskriften slettes.',
  'bank.deleteMatchGroupOffline': 'Kontoudskriften indgår i en matchgruppe. Prøv igen, når du er online.',
  'bank.noArchivedStatements': 'Ingen arkiverede kontoudskrifter endnu.',
  'bank.archivedHelp': 'Færdigafstemte perioder havner her, når alle linjer er behandlet og arkiveret.',
  'bank.uploadFile': 'Upload fil',
  'bank.opPrivArchive': 'Drift / Privat / Arkiv',
  'bank.opPrivArchiveHelp': '»Drift« afstemmer virksomhedens driftskonto. »Privat« bruges til at rydde op i en privatkonto og flytte virksomhedsrelaterede linjer over til driften. »Arkiv« viser færdigafstemte kontoudskrifter.',
  'bank.privateNotLinked': 'En privatkonto er personlig og tilknyttes ikke virksomhedens bankkonto.',
  'bank.bankAccount': 'Bankkonto',
  'bank.bankAccountHelp': 'Vælg, hvilken bankkonto du afstemmer. Hver konto har sit eget kontonummer i kontoplanen (f.eks. 1920 driftskonto, 1950 skattetrækskonto) og sine egne kontoudskrifter.',
  'bank.noAccountsSetUp': 'Der er ikke oprettet nogen bankkonti',
  'bank.noStatements': 'Ingen kontoudskrifter endnu.',
  'bank.noStatementsHelp': 'Upload en bankfil for den valgte konto, eller kontrollér, at den rigtige virksomhed er valgt.',
  'bank.connectBank': 'Forbind til banken',
  'bank.connectBankHelp': 'Forbind Plumme direkte til din bank via sikker Open Banking. Så hentes transaktionerne automatisk, og SuperPlumma bogfører og afstemmer løbende — så du slipper for at uploade kontoudskrifter manuelt.',
  'bank.connectYourBank': 'Forbind til din bank',
  'bank.connect': 'Forbind',
  'altinn.sub': 'Send skemaer videre til myndighederne — vi udfylder det, vi kan, på forhånd.',
  'altinn.filingVia': 'Indsendelse via Altinn',
  'altinn.open': 'Åbn Altinn',
  'altinn.openHelp': 'Åbner Altinn-portalen i en ny fane, hvor du logger ind med dit ID og fuldfører indsendelsen af de forudfyldte skemaer.',
  'altinn.formsAndStatus': 'Skemaer og status',
  'altinn.formsAndStatusHelp': 'Oversigt over de offentlige skemaer, virksomheden skal indsende, med RF-referencenummer og status. Status viser, om skemaet er indsendt, snart forfalder eller ikke er indsendt endnu.',
  'altinn.form': 'Skema',
  'altinn.formHelp': 'Navnet på det offentlige skema. RF-nummeret i næste kolonne er Skatteetatens officielle reference for skemaet.',
  'altinn.statusHelp': '»Indsendt« er sendt ind, »Forfalder snart« nærmer sig fristen, og »Ikke indsendt« mangler at blive sendt.',
  'setl.sub': 'Virksomhed, fakturering, bank og notifikationer - alt samlet ét sted.',
  'setl.companyInfo': 'Virksomhedsoplysninger',
  'setl.companyName': 'Virksomhedsnavn',
  'setl.invoiceSettings': 'Fakturaindstillinger',
  'setl.nextInvoiceNo': 'Næste fakturanummer',
  'setl.defaultPaymentTerms': 'Standard betalingsfrist',
  'setl.defaultVatRate': 'Standard momssats',
  'setl.reminderFee': 'Rykkergebyr',
  'setl.sendCopyToMe': 'Send kopi til mig',
  'setl.sendCopyHelp': 'Få en kopi af hver faktura på e-mail.',
  'setl.bankAndAccount': 'Bank og konto',
  'setl.mainLedgerAccount': 'Hovedkonto i regnskabet',
  'setl.notifications': 'Notifikationer',
  'km.pageHelp': 'Kørebogen dokumenterer erhvervskørsel og privat brug af firmabil. Erhvervsture giver kørselsgodtgørelse efter statens sats, mens privat kørsel logges uden fradrag.',
  'km.newTrip': 'Ny tur',
  'km.tripType': 'Turtype',
  'km.typeBusiness': 'Erhverv',
  'km.typePrivate': 'Privat',
  'km.privateUse': 'Privat brug',
  'km.privatePurposePh': 'Privat brug (valgfrit)',
  'km.privateNote': 'Privat kørsel logges, men giver ikke fradrag og bogføres ikke.',
  'km.ownCar': 'Egen bil',
  'km.startPlace': 'Startsted',
  'km.stopN': 'Stop {n}',
  'km.stopPh': 'Adresse undervejs',
  'km.destination': 'Destination',
  'km.calculating': 'Beregner...',
  'km.saveChanges': 'Gem ændringer',
  'km.saveEntry': 'Gem kørebogspost',
  'km.privateDriving': 'Privat kørsel',
});
